import moment from 'moment';

export const joinDateAndTime = (date: Date, time: string) => {
  const _date = moment(date, 'DD/MM/YYYY', true);
  const _time = moment(time, 'HH:mm', true);

  if (!_date.isValid() || !_time.isValid()) {
    throw new Error('Please provide valid date and time');
  }

  const combinedDateTime = _date.clone().set({
    hour: _time.hours(),
    minute: _time.minutes(),
  });

  return moment(combinedDateTime);
};
